import { classifyRefusal, isApiRefusalError } from "../errors";
import type { ApiRefusal, RefusalCase } from "../errors";

/** What the edge says about a maintenance hold: when it should end (if it knows), what keeps working, and an optional team note. */
export type MaintenanceNotice = Omit<Extract<RefusalCase, { kind: "MAINTENANCE" }>, "kind"> & {
  /** The host that answered, so the waiting screen can ask it again. */
  readonly url?: string;
};

/** The maintenance hold in a refusal, or nothing when the refusal is anything else. */
export function refusalNotice(refusal: ApiRefusal): MaintenanceNotice | undefined {
  const found = classifyRefusal(refusal);
  if (found.kind !== "MAINTENANCE") return undefined;
  const { kind, ...notice } = found;
  void kind;
  return { ...notice, ...(refusal.url === undefined ? {} : { url: refusal.url }) };
}

/** The maintenance hold inside an error, or nothing when the error is anything else. */
export function maintenanceNotice(error: unknown): MaintenanceNotice | undefined {
  return isApiRefusalError(error) ? refusalNotice(error.refusal) : undefined;
}
